exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cities-list {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Cities/components/CitiesList/CitiesList.less
// module id = 1107
// module chunks = 0